import { render } from "./TrendMetric.vue?vue&type=template&id=8ec282f6"
import script from "./TrendMetric.vue?vue&type=script&lang=js"
export * from "./TrendMetric.vue?vue&type=script&lang=js"

import exportComponent from "/home/nginx/domains/panel.vip-mod.net/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"TrendMetric.vue"]])

export default __exports__